export default "__VITE_ASSET__jUVLpD2z__"